import AppConstants from '../constants/AppConstants';
import PublisherActions from '../actions/PublisherActions';
import LinksActions from '../actions/LinksActions';
import store from '../stores/redux';

const methodNames = {
    Advertiser: 'callAdvertisers',
    Period: 'callPeriods',
    Offer: 'callOffers',
    UtmMedium: 'callUtmMedium',
    UtmSource: 'callUtmSource',
    UtmCampaign: 'callUtmCampaign',
    UtmTerm: 'callUtmTerm',
    UtmContent: 'callUtmContent',
    Param2: 'callReactivationParam2',
    UnactivePeriod: 'callReactivationUnactivePeriod',
    CreativeType: 'callCreativeType',
    CreativeLinkId: 'callCreativeLink',
    CreativeContainerId: 'callCreativeContainer',
    CreativeBannerId: 'callCreativeBanner',
    CreativeLandingId: 'callCreativeLanding',
    CreativePromoCodeId: 'callCreativePromoCode',
    Goal: 'callGoals',
    Link: 'callLinks',
    Country: 'callCountries',
    Referrer: 'callReferrers',
    Referral: 'callReferrals',
    OfferReferrer: 'callOffersReferrer',
    AdvertiserReferrer: 'callAdvertisersReferrer',
    Conversions: 'callConversions',
    TotalRows: 'callTotalRows'
};

const events = {
    before: AppConstants.DYNAMIC_SEGMENT_SEARCH_START,
    success: AppConstants.DYNAMIC_SEGMENT_SUCCESS,
    fail: AppConstants.DYNAMIC_SEGMENT_FAIL
};

const DynamicSelectSegmentController = {
    searchDataSegment(data, callback) {
        this[methodNames[data.segment]](data.params || {}, callback);
    },

    callAdvertisers(params, callback) {
        PublisherActions.getAdvertisers(params, () => {
            _successQuery({
                ...params,
                dataKey: 'advertisers',
            }, callback);
        }, events);
    },

    callPeriods(params, callback) {
        PublisherActions.getPeriods(params, () => {
            _successQuery({
                ...params,
                dataKey: 'periods',
            }, callback, false);
        }, events);
    },

    callOffers(params, callback) {
        PublisherActions.getOffers(params, () => {
            _successQuery({
                ...params,
                dataKey: 'offers',
            }, callback);
        }, events);
    },

    callCountries(params, callback) {
        PublisherActions.getCountries(params, () => {
            _successQuery({
                ...params,
                dataKey: 'countries',
            }, callback);
        }, events);
    },

    callReferrers(params, callback) {
        PublisherActions.getReferrers(params, () => {
            _successQuery({
                ...params,
                dataKey: 'referrers',
            }, callback);
        }, events);
    },

    callReferrals(params, callback) {
        PublisherActions.getReferrals(params, () => {
            _successQuery({
                ...params,
                dataKey: 'referrals',
            }, callback);
        }, events);
    },

    callOffersReferrer(params, callback) {
        PublisherActions.getOffersReferrer(params, () => {
            _successQuery({
                ...params,
                dataKey: 'offersReferral',
            }, callback);
        }, events);
    },

    callAdvertisersReferrer(params, callback) {
        PublisherActions.getAdvertisersReferrer(params, () => {
            _successQuery({
                ...params,
                dataKey: 'advertisersReferral',
            }, callback);
        }, events);
    },

    callUtmMedium(params, callback) {
        PublisherActions.getUtmMedium(params, () => {
            _successQuery({
                ...params,
                dataKey: 'utmMedium',
            }, callback);
        }, events);
    },

    callUtmSource(params, callback) {
        PublisherActions.getUtmSource(params, () => {
            _successQuery({
                ...params,
                dataKey: 'utmSource',
            }, callback);
        }, events);
    },

    callUtmCampaign(params, callback) {
        PublisherActions.getUtmCampaign(params, () => {
            _successQuery({
                ...params,
                dataKey: 'utmCampaign',
            }, callback);
        }, events);
    },

    callUtmTerm(params, callback) {
        PublisherActions.getUtmTerm(params, () => {
            _successQuery({
                ...params,
                dataKey: 'utmTerm',
            }, callback);
        }, events);
    },

    callUtmContent(params, callback) {
        PublisherActions.getUtmContent(params, () => {
            _successQuery({
                ...params,
                dataKey: 'utmContent',
            }, callback);
        }, events);
    },

    callReactivationParam2(params, callback) {
        PublisherActions.getReactivationParam2(params, () => {
            _successQuery({
                ...params,
                dataKey: 'param2',
            }, callback);
        }, events);
    },

    callReactivationUnactivePeriod(params, callback) {
        PublisherActions.getReactivationUnactivePeriod(params, () => {
            _successQuery({
                ...params,
                dataKey: 'unactivePeriod',
            }, callback);
        }, events);
    },

    callCreativeType(params, callback) {
        PublisherActions.getCreativeType(params, () => {
            _successQuery({
                ...params,
                dataKey: 'creativeType'
            }, callback, false);
        }, events);
    },

    callCreativeLink(params, callback) {
        PublisherActions.getCreativeLink(params, () => {
            _successQuery({
                ...params,
                dataKey: 'creativeLink',
            }, callback, false);
        }, events);
    },

    callCreativeContainer(params, callback) {
        PublisherActions.getCreativeContainer(params, () => {
            _successQuery({
                ...params,
                dataKey: 'creativeContainer',
            }, callback, false);
        }, events);
    },

    callCreativeBanner(params, callback) {
        PublisherActions.getCreativeBanner(params, () => {
            _successQuery({
                ...params,
                dataKey: 'creativeBanner',
            }, callback, false);
        }, events);
    },

    callCreativeLanding(params, callback) {
        PublisherActions.getCreativeLanding(params, () => {
            _successQuery({
                ...params,
                dataKey: 'creativeLanding',
            }, callback, false);
        }, events);
    },

    callCreativePromoCode(params, callback) {
        PublisherActions.getCreativePromoCode(params, () => {
            _successQuery({
                ...params,
                dataKey: 'creativePromoCode',
            }, callback, false);
        }, events);
    },

    callGoals(params, callback) {
        PublisherActions.getGoals(params, () => {
            _successQuery({
                ...params,
                dataKey: 'goals',

            }, callback);
        }, events);
    },

    callLinks(params, callback) {
        LinksActions.getListLinks(params, () => {
            _successQuery({
                ...params,
                dataKey: 'links',
            }, callback);
        }, events);
    },

    callConversions(params, callback) {
        PublisherActions.getConversions(params, () => {
            _successQuery({
                ...params,
                dataKey: 'conversions',
            }, callback);
        }, events);
    },

    callTotalRows(params, callback) {
        PublisherActions.getTotalRows(params, () => {
            _successQuery({
                ...params,
                dataKey: 'totalItems',
            }, callback);
        }, events);
    }
};

const _successQuery = (params, callback, withId = true) => {
    const data = store.getState().dynamicSegment;
    let list;
    if (withId) {
        list = _formatData(data.list, params.dataKey);
    } else {
        list = _formatDataNoId(data.list, params.dataKey);
    }

    callback && callback({
        ...data,
        list
    });
};

const _formatData = (data, key) => {
    const getTitle = {
        common: item => item.title,
        conversions: item => item.action.title
    };

    return data.map(item => {
        let title = getTitle[key] && getTitle[key](item) || getTitle.common(item);

        return {
            ...item,
            value: item.id,
            title: (item.id === title) ? item.id : `(${item.id}) ${title}`
        };
    });
};

const _formatDataNoId = (data, key) => {
    const getTitle = {
        common: item => item.title,
        conversions: item => item.action.title
    };

    return data.map(item => {
        let title = getTitle[key] && getTitle[key](item) || getTitle.common(item);

        return {
            ...item,
            value: item.id,
            title: `${title}`
        };
    });
};

export default DynamicSelectSegmentController;
